import * as React from 'react';


export default class UploadPpt extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <svg className={this.props.className} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 50 62">
                <defs>
                    <path id="a" d="M48.941 11.596v45.816a2.824 2.824 0 0 1-2.823 2.823H2.824A2.824 2.824 0 0 1 0 57.412V2.824A2.824 2.824 0 0 1 2.824 0h34.522a3 3 0 0 1 2.12.879l8.596 8.595a3 3 0 0 1 .88 2.122z"/>
                </defs>
                <g fill="none" fillRule="evenodd">
                    <g transform="translate(.53 .882)">
                        <use fill="#FFF" xlinkHref="#a"/>
                        <path stroke="#E4E4E4" strokeWidth="2" d="M47.941 11.596a2 2 0 0 0-.586-1.415L38.76 1.586A2 2 0 0 0 37.346 1H2.824A1.824 1.824 0 0 0 1 2.824v54.588c0 1.007.816 1.823 1.824 1.823h43.294a1.824 1.824 0 0 0 1.823-1.823V11.596z"/>
                    </g>
                    <path fill="#C9421B" d="M13.56 48.64v4.007h-2.343V41.272h4.437c.854 0 1.606.156 2.254.469.649.312 1.147.756 1.496 1.332.35.575.524 1.23.524 1.965 0 1.114-.382 1.993-1.145 2.636-.763.644-1.819.965-3.168.965H13.56zm0-1.9h2.094c.62 0 1.093-.145 1.418-.437.326-.291.488-.708.488-1.25 0-.557-.164-1.008-.492-1.351-.328-.344-.781-.521-1.36-.532H13.56v3.57zm10.32 1.9v4.007h-2.343V41.272h4.437c.855 0 1.606.156 2.254.469.649.312 1.148.756 1.496 1.332.35.575.524 1.23.524 1.965 0 1.114-.382 1.993-1.145 2.636-.763.644-1.819.965-3.168.965h-2.054zm0-1.9h2.094c.62 0 1.093-.145 1.418-.437.326-.291.489-.708.489-1.25 0-.557-.164-1.008-.492-1.351-.329-.344-.782-.521-1.36-.532h-2.148v3.57zm16.54-3.57h-3.485v9.477h-2.343V43.17h-3.438v-1.898h9.266v1.898z"/>
                    <path fill="#C9421B" d="M6.176 17.823h37.647v4.706H6.176zM6.176 7.47H32.53v4.706H6.176zM6.176 28.176h37.647v4.706H6.176z" opacity=".1"/>
                    <path fill="#CA431C" d="M36.884 5.728v6.89a.5.5 0 0 0 .5.5h6.889a.5.5 0 0 0 .354-.854l-6.89-6.89a.5.5 0 0 0-.853.354z"/>
                </g>
            </svg>
        )
    }
}
